export default class Dropdown {
  constructor(root) {
    this.root = root;

    this.toggleBtn = this.root.querySelector('[data-dropdown-trigger]');
    this.content = this.root.querySelector('[data-dropdown-content]');

    if (!this.content) {
      this.content = this.root.querySelector('.u-dropdown');
    }

    if (!this.content) {
      return console.error('no dropdown content detected');
    }

    this.isOpen = false;
    this.bind();
  }

  bind() {
    this.toggle = this.toggle.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);

    this.toggleBtn && this.toggleBtn.addEventListener('click', this.toggle);
    document.body.addEventListener('click', this.onClickOutside);
    document.body.addEventListener('touchend', this.onClickOutside);
  }

  destroy() {
    this.toggleBtn && this.toggleBtn.removeEventListener('click', this.toggle);
    document.body.removeEventListener('click', this.onClickOutside);
    document.body.removeEventListener('touchend', this.onClickOutside);
  }

  onClickOutside(e) {
    if (!this.isOpen) {
      return;
    }

    let el = e.target;
    let isRoot = (el) => {
      return el && el === this.root;
    };

    while (el && !isRoot(el)) {
      el = el.parentNode;
    }

    if (!isRoot(el)) {
      this.close();
    }
  }

  toggle(e) {
    e && e.preventDefault();
    this[this.isOpen ? 'close' : 'open']();
  }

  open() {
    this.content.style.display = 'block';
    this.toggleBtn.classList.add('is-open');
    this.isOpen = true;
  }

  close() {
    this.content.style.display = 'none';
    this.toggleBtn.classList.remove('is-open');
    this.isOpen = false;
  }
}
